import { Stack } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import React from 'react';
import { defaultBorder } from '../../../Theme';
import AdditionalDocsTreeView from '../AdditionalDocsTreeView/AdditionalDocsTreeView';

/**
 * "Master Detail" section of a DataGrid row that shows the top-level additional documents for a document row.
 */
export default ({ row }: IDocTableAdditionalDocsProps) => {
    return (
        <Stack sx={{ height: '100%', borderBottom: defaultBorder }}>
            <AdditionalDocsTreeView universalId={row.UniversalID} noteId={row.NoteId} />
        </Stack>
    );
};

/**
 * Interface for the props of a DocTableAdditionalDocs component.
 */
export interface IDocTableAdditionalDocsProps {
    row: GridValidRowModel;
}
